// @ts-nocheck
import * as Types from '../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import { DisplayNamedFragmentDoc, NamedFragmentDoc } from '../../../fragments/commonFragments.generated';
import * as ApolloReactCommon from 'src/apolloHooks';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type UnitBasedBidsTableQueryVariables = Types.Exact<{
  bidPackageVersionId: Types.Scalars['ID']['input'];
  highlightChanges: Types.Scalars['Boolean']['input'];
}>;


export type UnitBasedBidsTableQuery = { __typename?: 'Query', bidPackageVersion: { __typename?: 'BidPackageVersion', id: string, lineItems: Array<{ __typename?: 'BidPackageLineItem', id: string, isInUse: boolean, hasBidderCost: boolean, isMissingCost: boolean, bidItem: { __typename?: 'BidItem', id: string, displayName: string, costType: { __typename?: 'CostTypeDetail', code: Types.CostType }, parentMaterialVariant?: { __typename?: 'MaterialVariant', id: string, code: string, displayName: string, modelNumber?: string | null | undefined } | null | undefined, parentTask?: { __typename?: 'GlobalPlanTask', id: string, name: string } | null | undefined, unitOfMeasure: { __typename?: 'UnitOfMeasure', id: string, shortName: string }, items: Array<{ __typename?: 'Item', id: string, displayName: string, costCode: { __typename?: 'CostCode', name: string, number: string, id: string, displayName: string } }> } }>, previous?: { __typename?: 'BidPackageVersion', id: string, lineItems: Array<{ __typename?: 'BidPackageLineItem', id: string, bidItem: { __typename?: 'BidItem', id: string, displayName: string, costType: { __typename?: 'CostTypeDetail', code: Types.CostType }, parentMaterialVariant?: { __typename?: 'MaterialVariant', id: string, code: string, displayName: string, modelNumber?: string | null | undefined } | null | undefined, parentTask?: { __typename?: 'GlobalPlanTask', id: string, name: string } | null | undefined, unitOfMeasure: { __typename?: 'UnitOfMeasure', id: string, shortName: string }, items: Array<{ __typename?: 'Item', id: string, displayName: string, costCode: { __typename?: 'CostCode', name: string, number: string, id: string, displayName: string } }> } }>, latestBidContractRevisions: Array<{ __typename?: 'BidContractRevision', id: string, bidContract: { __typename?: 'BidContract', id: string, tradePartner?: { __typename?: 'TradePartner', id: string, name: string } | null | undefined }, lineItems: Array<{ __typename?: 'BidContractLineItem', id: string, totalCostInCents: number, userSet: boolean, bidItem?: { __typename?: 'BidItem', id: string } | null | undefined }> }> } | null | undefined } };

export type UnitBasedBidsTable_BidPackageVersionFragment = { __typename?: 'BidPackageVersion', id: string, lineItems: Array<{ __typename?: 'BidPackageLineItem', id: string, isInUse: boolean, hasBidderCost: boolean, isMissingCost: boolean, bidItem: { __typename?: 'BidItem', id: string, displayName: string, costType: { __typename?: 'CostTypeDetail', code: Types.CostType }, parentMaterialVariant?: { __typename?: 'MaterialVariant', id: string, code: string, displayName: string, modelNumber?: string | null | undefined } | null | undefined, parentTask?: { __typename?: 'GlobalPlanTask', id: string, name: string } | null | undefined, unitOfMeasure: { __typename?: 'UnitOfMeasure', id: string, shortName: string }, items: Array<{ __typename?: 'Item', id: string, displayName: string, costCode: { __typename?: 'CostCode', name: string, number: string, id: string, displayName: string } }> } }>, previous?: { __typename?: 'BidPackageVersion', id: string, lineItems: Array<{ __typename?: 'BidPackageLineItem', id: string, bidItem: { __typename?: 'BidItem', id: string, displayName: string, costType: { __typename?: 'CostTypeDetail', code: Types.CostType }, parentMaterialVariant?: { __typename?: 'MaterialVariant', id: string, code: string, displayName: string, modelNumber?: string | null | undefined } | null | undefined, parentTask?: { __typename?: 'GlobalPlanTask', id: string, name: string } | null | undefined, unitOfMeasure: { __typename?: 'UnitOfMeasure', id: string, shortName: string }, items: Array<{ __typename?: 'Item', id: string, displayName: string, costCode: { __typename?: 'CostCode', name: string, number: string, id: string, displayName: string } }> } }>, latestBidContractRevisions: Array<{ __typename?: 'BidContractRevision', id: string, bidContract: { __typename?: 'BidContract', id: string, tradePartner?: { __typename?: 'TradePartner', id: string, name: string } | null | undefined }, lineItems: Array<{ __typename?: 'BidContractLineItem', id: string, totalCostInCents: number, userSet: boolean, bidItem?: { __typename?: 'BidItem', id: string } | null | undefined }> }> } | null | undefined };

export type UnitBasedBidsTable_BidItemFragment = { __typename?: 'BidItem', id: string, displayName: string, costType: { __typename?: 'CostTypeDetail', code: Types.CostType }, parentMaterialVariant?: { __typename?: 'MaterialVariant', id: string, code: string, displayName: string, modelNumber?: string | null | undefined } | null | undefined, parentTask?: { __typename?: 'GlobalPlanTask', id: string, name: string } | null | undefined, unitOfMeasure: { __typename?: 'UnitOfMeasure', id: string, shortName: string }, items: Array<{ __typename?: 'Item', id: string, displayName: string, costCode: { __typename?: 'CostCode', name: string, number: string, id: string, displayName: string } }> };

export const UnitBasedBidsTable_BidItemFragmentDoc = gql`
    fragment UnitBasedBidsTable_BidItem on BidItem {
  ...DisplayNamed
  costType {
    code
  }
  parentMaterialVariant {
    id
    code
    displayName
    modelNumber
  }
  parentTask {
    id
    name
  }
  unitOfMeasure {
    id
    shortName
  }
  items {
    ...DisplayNamed
    costCode {
      ...DisplayNamed
      name
      number
    }
  }
}
    ${DisplayNamedFragmentDoc}`;
export const UnitBasedBidsTable_BidPackageVersionFragmentDoc = gql`
    fragment UnitBasedBidsTable_BidPackageVersion on BidPackageVersion {
  id
  lineItems {
    id
    isInUse
    hasBidderCost
    isMissingCost
    bidItem {
      ...UnitBasedBidsTable_BidItem
    }
  }
  previous @include(if: $highlightChanges) {
    id
    lineItems {
      id
      bidItem {
        ...UnitBasedBidsTable_BidItem
      }
    }
    latestBidContractRevisions {
      id
      bidContract {
        id
        tradePartner {
          ...Named
        }
      }
      lineItems {
        id
        bidItem {
          id
        }
        totalCostInCents
        userSet
      }
    }
  }
}
    ${UnitBasedBidsTable_BidItemFragmentDoc}
${NamedFragmentDoc}`;
export const UnitBasedBidsTableDocument = gql`
    query UnitBasedBidsTable($bidPackageVersionId: ID!, $highlightChanges: Boolean!) {
  bidPackageVersion(id: $bidPackageVersionId) {
    ...UnitBasedBidsTable_BidPackageVersion
  }
}
    ${UnitBasedBidsTable_BidPackageVersionFragmentDoc}`;

/**
 * __useUnitBasedBidsTableQuery__
 *
 * To run a query within a React component, call `useUnitBasedBidsTableQuery` and pass it any options that fit your needs.
 * When your component renders, `useUnitBasedBidsTableQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUnitBasedBidsTableQuery({
 *   variables: {
 *      bidPackageVersionId: // value for 'bidPackageVersionId'
 *      highlightChanges: // value for 'highlightChanges'
 *   },
 * });
 */
export function useUnitBasedBidsTableQuery(baseOptions: ApolloReactHooks.QueryHookOptions<UnitBasedBidsTableQuery, UnitBasedBidsTableQueryVariables> & ({ variables: UnitBasedBidsTableQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<UnitBasedBidsTableQuery, UnitBasedBidsTableQueryVariables>(UnitBasedBidsTableDocument, options);
      }
export function useUnitBasedBidsTableLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<UnitBasedBidsTableQuery, UnitBasedBidsTableQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<UnitBasedBidsTableQuery, UnitBasedBidsTableQueryVariables>(UnitBasedBidsTableDocument, options);
        }
// @ts-ignore
export function useUnitBasedBidsTableSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<UnitBasedBidsTableQuery, UnitBasedBidsTableQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<UnitBasedBidsTableQuery, UnitBasedBidsTableQueryVariables>;
export function useUnitBasedBidsTableSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<UnitBasedBidsTableQuery, UnitBasedBidsTableQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<UnitBasedBidsTableQuery | undefined, UnitBasedBidsTableQueryVariables>;
export function useUnitBasedBidsTableSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<UnitBasedBidsTableQuery, UnitBasedBidsTableQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<UnitBasedBidsTableQuery, UnitBasedBidsTableQueryVariables>(UnitBasedBidsTableDocument, options);
        }
export type UnitBasedBidsTableQueryHookResult = ReturnType<typeof useUnitBasedBidsTableQuery>;
export type UnitBasedBidsTableLazyQueryHookResult = ReturnType<typeof useUnitBasedBidsTableLazyQuery>;
export type UnitBasedBidsTableSuspenseQueryHookResult = ReturnType<typeof useUnitBasedBidsTableSuspenseQuery>;
export type UnitBasedBidsTableQueryResult = ApolloReactCommon.QueryResult<UnitBasedBidsTableQuery, UnitBasedBidsTableQueryVariables>;